import { clsx } from 'clsx';
import { Fragment } from 'react';

import { BloomLink } from '@jane/bloom/components/bloomLink';
import type { Breadcrumb } from '@jane/bloom/types/breadcrumb';

import styles from './breadcrumbs.module.css';

export interface BreadcrumbsProps {
  breadcrumbs: Breadcrumb[];
  className?: string;
  visibleOnViewports?: 'desktop' | 'all';
}

export function Breadcrumbs({
  breadcrumbs,
  className,
  visibleOnViewports = 'all',
}: BreadcrumbsProps) {
  return (
    <div
      className={clsx(
        styles['breadcrumbs'],
        {
          [styles['breadcrumbs--desktop-only']]:
            visibleOnViewports === 'desktop',
        },
        className
      )}
    >
      {breadcrumbs.map(({ label, to }, index) => (
        <Fragment key={label}>
          {to ? (
            <BloomLink to={to} variant="reefer-underline">
              {label}
            </BloomLink>
          ) : (
            <div className={styles['breadcrumbText']}>{label}</div>
          )}
          {index !== breadcrumbs.length - 1 ? <span> /</span> : null}
        </Fragment>
      ))}
    </div>
  );
}
